"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var slugline = _interopRequireWildcard(require("@krad/slugline"));

var _manson = _interopRequireDefault(require("@krad/manson"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Muxer =
/*#__PURE__*/
function () {
  function Muxer() {
    _classCallCheck(this, Muxer);

    this.transmuxer = new slugline.Transmuxer();
  }
  /**
   * transcode - Transmuxes a transport stream segment into a fmp4 segment
   *
   * @param  {Uint8Array} bytes An array of unsigned 8 bit integers representing the TS segment
   * @return {Promise<Array<Uint8Array>>} Returns an array of Uint8Array.  Arrays greater than 1 in length mean an init segment is at the front
   */


  _createClass(Muxer, [{
    key: "transcode",
    value: function () {
      var _transcode = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(bytes) {
        var _this = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _manson.default.info('transmuxing new segment');

                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  _manson.default.trace("parsing segment...");

                  var ts = slugline.TransportStream.parse(bytes);

                  _manson.default.trace('segment parsed.');

                  _manson.default.trace('starting transmux...');

                  _this.transmuxer.setCurrentStream(ts);

                  _manson.default.trace('setup state...');

                  var res = _this.transmuxer.build();

                  _manson.default.trace('transmux struct built.');

                  var result = [];

                  if (_this.initSegment === undefined) {
                    _manson.default.trace('building init segment...');

                    _this.initSegment = _this.transmuxer.buildInitializationSegment(res[0]);
                    result.push(_this.initSegment);
                  }

                  _manson.default.trace('building media info from segment...');

                  var media = _this.transmuxer.buildMediaSegment(res);

                  result.push(media);

                  _manson.default.info('transmuxing complete.');

                  resolve(result);
                }));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function transcode(_x) {
        return _transcode.apply(this, arguments);
      };
    }()
  }]);

  return Muxer;
}();

exports.default = Muxer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@krad/plainview/distribution/muxer.js
// module id = 483
// module chunks = 0